import { render, staticRenderFns } from "./CopyLegal.vue?vue&type=template&id=29d22f7f"
import script from "./CopyLegal.vue?vue&type=script&lang=js"
export * from "./CopyLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports